import { OrganizationDetailFragment } from '@alice-financial/alice-sdk'
import { HealthcheckStatusResult } from '../types'

export const usePayrollConnectionStatus = (
  org: OrganizationDetailFragment
): Pick<HealthcheckStatusResult, 'status' | 'secondary'> => {
  const isOnboarded = Boolean(org.isOnboarded)
  const isPayrollConnected = isOnboarded || Boolean(org.payrollConnection.payrollConnectedAt)
  const isDoneWithPayrollInstructions =
    isOnboarded || isPayrollConnected || Boolean(org.payrollConnection.payrollInstructionsCompletedAt)

  return {
    status: isPayrollConnected ? 'complete' : isDoneWithPayrollInstructions ? 'pending' : 'incomplete',
    secondary: isPayrollConnected
      ? 'Payroll connected'
      : isDoneWithPayrollInstructions
        ? 'We are confirming your payroll connection'
        : 'Allow Alice to process deductions and contributions',
  }
}
